import { render, staticRenderFns } from "./InstrucaoForm.vue?vue&type=template&id=3b1f223e"
import script from "./InstrucaoForm.vue?vue&type=script&lang=js"
export * from "./InstrucaoForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports